export default "__VITE_ASSET__BioUAwxN__"